import { Injectable } from '@angular/core';
import { AlarmAgentApiClient } from './api-client.service';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class NewRtuService {
	private API_ROUTE = 'admin/new-rtu';

	constructor(private http: AlarmAgentApiClient) {}

	getFirmwareOptions(): Observable<FirmwareOption[]> {
		return this.http.get(`${this.API_ROUTE}/firmware-options`);
	}

	getMagicWord(): Observable<string> {
		return this.http.get(`${this.API_ROUTE}/create-magic-word`, {
			responseType: 'text',
		});
	}

	getNextCsid(): Observable<number> {
		return this.http.get(`${this.API_ROUTE}/next-csid`);
	}

	getRtuStatusOptions(): Observable<RtuStatusOption[]> {
		return this.http.get(`${this.API_ROUTE}/rtu-status-options`);
	}

	getSimTypeOptions(): Observable<SimTypeOption[]> {
		return this.http.get(`${this.API_ROUTE}/sim-type-options`);
	}

	getHardwareTypes(): Observable<SimTypeOption[]> {
		return this.http.get(`${this.API_ROUTE}/hardware-type-options`);
	}

	async saveNewRtu(newRTU: NewRTU): Promise<number> {
		return this.http.post(this.API_ROUTE, newRTU).toPromise();
	}

	async saveNewVerbatimRtu(newRTU: NewVerbatimRTU): Promise<number> {
		return this.http.post(`${this.API_ROUTE}/verbatim`, newRTU).toPromise();
	}
}

export class FirmwareOption {
	id?: number;
	name?: string;
	createDate?: Date;
}

export class RtuStatusOption {
	id?: string;
	name?: string;
}

export class SimTypeOption {
	id?: string;
	name?: string;
}

export class NewRTU {
	name?: string;
	imsi?: number;
	simType?: number;
	smsAddress?: number;
	imei?: number;
	rsn?: string;
	csid?: string;
	iccid?: string;
	firmwareVersionId?: number;
	boardRev?: string;
	magicWord?: string;
	rtuStatus?: number;
	hardwareClassId?: number;
}

export class NewVerbatimRTU {
	name?: string;
	potsNumber?: number;
	channelCount?: number;
	rsn?: string;
	csid?: string;
	magicWord?: string;
	rtuStatus?: number;
}
